import React from 'react';

//Assets and Css
import { Body, ButtonBox, Left, Right } from './Styled';
import person from '../../Assets/homeicon.svg';

//Components
import SideMenu from '../../Components/Sidemenu';
import Navbar from '../Navbar';
import Resume from './Resume.pdf';

const Index = () => {
    return (
        <>
            <SideMenu />
            <Navbar />
            <Body>
                <Left>
                    <div>
                        <h1>Hi, I am Vishu Goyal</h1>
                        <h1>A Software Developer</h1>
                        <h3>
                            <span style={{ color: 'black' }}>&lt;</span>
                            &nbsp; React & UI Enthusiast &nbsp;
                            <span style={{ color: 'black' }}>/&gt;</span>
                        </h3>
                        <ButtonBox className='butbox'>
                            <a href='#Contact'><button>Hire Me</button></a>
                            <a href={Resume} download> <button>Download CV</button></a>
                        </ButtonBox>
                    </div>
                </Left>
                <Right>
                    <img src={person} />
                </Right>
            </Body>
        </>
    );
}

export default Index;
